module.exports = __webpack_public_path__ + "img/Close.5e84566d.svg";